import { createSelector } from 'reselect'
import { denormalize } from 'normalizr'
import * as schema from './schema'

export const makeSelectSimsState = () => (state) => state.get('sims');

export const makeSelectReady = () => createSelector(
  makeSelectSimsState(),
  (substate) => substate.get('ready')
);

export const makeSelectFetching = () => createSelector(
  makeSelectSimsState(),
  (substate) => substate.get('fetching')
);

export const makeSelectNonActivatedSimsFetching = () => createSelector(
  makeSelectSimsState(),
  (substate) => substate.get('nonActivatedSimsFetching')
);

export const makeSelectCurrentSimFetchFinished = () => createSelector(
  makeSelectSimsState(),
  (substate) => substate.get('currentSimFetchFinished')
);


export const makeSelectEntities = () => createSelector(
  makeSelectSimsState(),
  (substate) => substate.get('entities')
);

export const makeSelectResult = () => createSelector(
  makeSelectSimsState(),
  (substate) => substate.get('result')
);

export const makeSelectSims = () => createSelector(
  makeSelectEntities(),
  makeSelectResult(),
  (entities, result) => {
    if (result === null) {
      return null;
    }
    return denormalize(result, schema.sims, entities).toJS()
  }
);

export const makeSelectCurrentOrder = () => createSelector(
  makeSelectSimsState(),
  (substate) => {
    const data = substate.get('currentOrder');
    if (data !== null) {
      return data.toJS()
    }
    return null
  }
);

export const makeSelectCurrentSimData = () => createSelector(
  makeSelectSimsState(),
  (substate) => {
    const data = substate.get('currentSim');
    if (data !== null) {
      return data.toJS()
    }
    return null
  }
);


// TODO: specifioi errorit
export const makeSelectUpdateOrderFinished = () => createSelector(
  makeSelectSimsState(),
  (substate) => substate.get('updateOrderFinished')
);


export const makeSelectNonActivatedSims = () => createSelector(
  makeSelectSimsState(),
  (substate) => substate.get('nonActivatedSims').toJS()
);